import { TopBar } from '@/layouts/TopBar';
import Paths from '@/routes/paths';
import { JButton } from '@atoms/JButton';
import { IconSize } from '@constants';
import EstablishmentsList from '@establishment/components/EstablishmentsList';
import useEstablishments from '@establishment/hooks/useEstablishments';
import { PlusIcon } from '@heroicons/react/24/outline';
import { Box, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const EstablishmentsPage = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const navigate = useNavigate();
  const { establishmentsCount } = useEstablishments();
  return (
    <>
      <TopBar title={t('ESTABLISHMENTS')} count={establishmentsCount}>
        <JButton
          variant="contained"
          color="secondary"
          onClick={() => navigate(Paths.CreateEstablishment)}
          startIcon={
            <PlusIcon
              color={theme.palette.white.main}
              height={IconSize.buttonIcon}
            />
          }
        >
          {t('NEW_ESTABLISHMENT')}
        </JButton>
      </TopBar>
      <Box m={2}>
        <EstablishmentsList />
      </Box>
    </>
  );
};

export default EstablishmentsPage;
